import axios from "axios";
import { getAccessTokenCookie } from "./authToken";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_CONTENT_URL,
  responseType: "json",
});

api.interceptors.request.use((config) => {
  const token = getAccessTokenCookie();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
